import React from "react";
import styles from "./QuotationLine.module.scss";

const QuotationLineGutter = ({
  index,
  quotation,
  changeLineOrder,
  setQuotationSelected,
  overOverlay,
}) => {
  return (
    <div className={styles.gutter} style={overOverlay}>
      <button
        type="button"
        className={styles.gutterArrow}
        title="Remonter dans la liste"
        onClick={() => changeLineOrder("down", index)}
      >
        <i className="fa fa-arrow-up" />
      </button>
      <input
        type="checkbox"
        className={styles.gutterCheck}
        title="Sélectionner cette ligne"
        aria-label="Sélectionner cette ligne"
        onChange={(e) => {
          if (e.target.checked) {
            setQuotationSelected((x) => [...x, quotation]);
          } else {
            setQuotationSelected((x) =>
              x.filter((xx) => xx.uuid !== quotation.uuid),
            );
          }
        }}
      />
      <span className={styles.gutterNum}>{index + 1}</span>
      <button
        type="button"
        className={styles.gutterArrow}
        title="Descendre dans la liste"
        onClick={() => changeLineOrder("up", index)}
      >
        <i className="fa fa-arrow-down" />
      </button>
    </div>
  );
};

export default QuotationLineGutter;
